"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable */
/* tslint:disable */
var React = require("react");
var Sound = function (_a) {
    var size = _a.size, props = __rest(_a, ["size"]);
    return (React.createElement("svg", __assign({ viewBox: "0 0 24 24", fill: "currentColor", width: size || "24", height: size || "24" }, props),
        React.createElement("path", { d: "M8.74898127,16 L5,16 C4.44771525,16 4,15.5522847 4,15 L4.00000052,14.9989818 L4.00509158,9.99898179 C4.00565351,9.44709492 4.4532039,9 5.00509106,9 L8.74898127,9 L13.0061088,6 L14.0061088,6 L14.0061088,19 L12.9989813,19 L8.74898127,16 Z M5.00610875,10 L4.99898127,15 L7.99898127,15 L7.99898127,10 L5.00610875,10 Z M8.99898127,10 L8.99898127,15 L12.9989813,17.75 L12.9989813,7.25 L8.99898127,10 Z M17.775454,6.58117085 C19.6770121,7.60430712 20.9989813,9.86970302 20.9989813,12.5 C20.9989813,15.130297 19.6770121,17.3956929 17.775454,18.4188292 L17.413844,17.4786431 C18.9415538,16.5993687 19.9989813,14.7006138 19.9989813,12.5 C19.9989813,10.2993862 18.9415538,8.40063128 17.413844,7.5213569 L17.775454,6.58117085 L17.775454,6.58117085 Z M16.6844602,9.41775475 C17.4671493,10.0090242 17.9989813,11.1675609 17.9989813,12.5 C17.9989813,13.8324391 17.4671493,14.9909758 16.6844602,15.5822452 L16.3085797,14.6049558 C16.7238594,14.1603608 16.9989813,13.3837288 16.9989813,12.5 C16.9989813,11.6162712 16.7238594,10.8396392 16.3085797,10.3950442 L16.6844602,9.41775475 L16.6844602,9.41775475 Z" })));
};
Sound.displayName = 'Sound';
exports.default = Sound;
/* tslint:enable */
/* eslint-enable */
//# sourceMappingURL=Sound.js.map